<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    xml:space="preserve">
    <g id="Black">
      <g>
        <polygon
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          points="7.5,21.5 4,23.5 0.5,21.5 0.5,18 4,16 7.5,18" />
        <polygon
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          points="23.5,21.5 20,23.5 16.5,21.5 16.5,18 20,16 23.5,18" />
        <polyline
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          points="4,19.5 7.5,8.5 10.5,8.5" />
        <polyline
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          points="15.65,12.5 20,19.5 12.5,19.5" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="15.5"
          y1="9.5"
          x2="18.5"
          y2="9.5" />
        <path
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M15.65,12.5H6.227 c0.273,0,6.273,7,6.273,7l4.5-10" />
      </g>
    </g>
  </svg>
</template>
